import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { TranchesRoutingModule } from './tranches-routing.module';
import { TrancheListaComponent } from './pesquisa/listagem/tranche-listagem.component'
import { TranchesCadastroComponent } from './cadastro/tranches-cadastro.component';
import { TrancheHistoricoComponent } from "./historico/tranche-historico.component";
import { ModalFatorEcgComponent } from './modal-fator-ecg/modal-fator-ecg.component';
import { ModalConfirmaFatorEcgComponent } from "./modal-confirma-fator-ecg/modal-confirma-fator-ecg";


@NgModule({
  imports:[
      SharedModule,
      BrowserModule,
      CommonModule,
      TranchesRoutingModule
  ],
  declarations:[
    TrancheListaComponent,
    TranchesCadastroComponent,
    TrancheHistoricoComponent,
    ModalFatorEcgComponent,
    ModalConfirmaFatorEcgComponent

  ],
  providers:[

  ]
})
export class TranchesModule {}
